export const title = `600 28px "Open Sans"`
export const subtitleLarge = `600 18px "Open Sans"`
export const subtitleMedium = `600 14px "Open Sans"`
export const subtitleSmall = `600 12px "Open Sans"`
export const body = `400 12px "Open Sans"`
export const appInfo = `600 10px "Open Sans"`
export const ctaLarge = `600 14px "Open Sans"`
export const ctaSmall = `600 12px "Open Sans"`
export const ranking = `600 10px "Open Sans"`
export const subtitleSmallSelected = `700 12px "Open Sans"`
export const subtitleLargeBold = `700 18px "Open Sans"`
export const wTitle = `700 38px "Poppins"`
export const ctaUnderline = `600 12px "Open Sans"`

const texts = {
  title,
  subtitleLarge,
  subtitleMedium,
  subtitleSmall,
  body,
  appInfo,
  ctaLarge,
  ctaSmall,
  ranking,
  subtitleSmallSelected,
  subtitleLargeBold,
  wTitle,
  ctaUnderline
}
export default texts